import 'quill';

export interface Config {
	container: string;
	maxLength: number;
	currentLength: any;
}

export interface QuillInstance {
	on: any;
	getText: any;
	updateContents;
}

export default class Counter {
	quill: QuillInstance;
	options: Config;
	currentLength: any;

	constructor(quill, options) {
		this.quill = quill;
		this.options = options;
		this.currentLength = this.options.currentLength;

		const container = document.getElementById(this.options.container);
		container.innerHTML = `0/${this.options.maxLength}`;

		this.quill.on('text-change', () => {
			const length = this.calculate();
			this.checkOutOfLimit(length, container);
			this.currentLength(length);
			container.innerHTML = `${length}/${this.options.maxLength}`;
		});
	}

	calculate() {
		const text = this.quill.getText();
		return text.length;
	}

	checkOutOfLimit(length, container) {
		if (length > this.options.maxLength) {
			if (!container.classList.contains('red')) {
				container.classList.add('red');
			}
		} else if (container.classList.contains('red')) {
			container.classList.remove('red');
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/components/common/sn-quill-editor/counter.ts